import { type ComponentProps, useEffect, useRef } from 'react';

import { type DayButton, getDefaultClassNames } from 'react-day-picker';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const DEFAULT_CLASS_NAMES = getDefaultClassNames();

export const DateRangeDayButton = ({
  className,
  day,
  modifiers,
  ...props
}: ComponentProps<typeof DayButton>) => {
  const ref = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (modifiers.focused) {
      ref.current?.focus();
    }
  }, [modifiers.focused]);

  const isEnd = modifiers.range_start || modifiers.range_end;
  const isSingle = modifiers.selected && !isEnd && !modifiers.range_middle;
  const isPill = isEnd || isSingle;

  const textColor = () => {
    if (isPill) {
      return 'text-text-primary-foreground';
    }
    if (modifiers.outside) {
      return 'text-foreground-muted';
    }
    return 'text-foreground';
  };

  return (
    <Button
      ref={ref}
      variant="ghost-neutral"
      size="icon-sm"
      data-day={day.date.toLocaleDateString()}
      className={cn(
        'flex size-9 flex-col items-center justify-center gap-0 rounded-lg p-1.5 text-sm leading-6 font-normal',
        textColor(),
        isPill && 'bg-surface-button-primary hover:bg-surface-button-primary',
        modifiers.range_middle && 'rounded-none bg-transparent',
        'group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10',
        DEFAULT_CLASS_NAMES.day,
        className
      )}
      {...props}
    />
  );
};
